import pricingData from './pricing-data.json';
import type { Period } from './types';

function sortByOrder<T extends { order: number }>(items: T[]): T[] {
  return [...items].sort((first, second) => first.order - second.order);
}

export const periods: Period[] = sortByOrder(pricingData.periods);
export const plans = pricingData.plans;
export const trackerFrequencies = sortByOrder(
  pricingData.addons.tracker.frequencies,
);
export const trackerResultDepths = sortByOrder(
  pricingData.addons.tracker.resultDepths,
);
export const walletPresetAmounts = pricingData.addons.wallet.presetAmounts;

export default pricingData;
